export async function downloadWaybillBlob(response, defaultFilename) {
  const blob = response.data
  if (!(blob instanceof Blob)) throw new Error('下载文件格式不正确')
  if (blob.type && blob.type.includes('json')) {
    const result = JSON.parse(await blob.text())
    throw new Error(result.msg || result.message || '下载失败')
  }
  const disposition = (response.headers || {})['content-disposition'] || ''
  const match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
  const filename = match ? decodeURIComponent(match[1]) : defaultFilename
  const url = window.URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  window.setTimeout(() => window.URL.revokeObjectURL(url), 1000)
}
